define('modules/image_picker/image_picker_collection',[
  'backbone',
  'jquery',
  '_',

  'session'
], function (Backbone, $, _, session) {
  'use strict';
  var ImagesCollection = Backbone.Collection.extend({

    default_params: {
      search: null,
      order_by: 'date_added',
      order: 'DESC',
      limit: 10
    },

    params: {},

    initialize: function (models, opts) {
      this.resetParams();
    },

    parse: function (response) {
      response.data.forEach(function (model) {
        model.preview_url = session.get('apiBaseUrl') + '/' + model.preview_url;

      });
      if (response.metadata) {
        this.params = _.extend(this.params, response.metadata);
      }
      return response.data;
    },

    resetParams: function () {
      this.params = _.extend({}, this.default_params);
    },

    url: function () {
      return session.get('apiUrl') + 'items?' + $.param(this.params || {});
    }

  });

  return ImagesCollection;
});

